import { render, staticRenderFns } from "./CreateMortgageProducts.vue?vue&type=template&id=23cd09ea"
import script from "./CreateMortgageProducts.vue?vue&type=script&lang=js"
export * from "./CreateMortgageProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports